import { Db } from '../repository/db';
import { Security } from '$lib/security';
import { jwtDecode } from 'jwt-decode';

export class Util {
	static async verifyToken() {
		if (this.getLoggedInUserInfo() != null) {
			let token = localStorage.getItem('token');
			const decoded = jwtDecode(token);
			console.dir(decoded);

			let currentTime = Date.now() / 1000;
			let expiryTime = decoded['exp'];

			if (currentTime >= expiryTime) {
				this.logoutUser();
			}
		}
	}

	static setupTrackdesk() {
		var cookie = document.cookie.match('(^|;)\\s*trakdesk_cid\\s*=\\s*([^;]+)');
		console.dir(document.cookie);
		if (Array.isArray(cookie)) {
			try {
				var trakdeskCid = JSON.parse(cookie.pop());
				var cid = trakdeskCid['cid'];
				document.querySelectorAll('a[href^="https://checkout.stripe.com"]').forEach(function (a) {
					var url = new URL(a.href);
					url.searchParams.set('client_reference_id', cid);
					a.href = url.href;
				});
				return cid;
			} catch (e) {
				console.log(e);
				return null;
			}
		}
	}

	static getLoggedInUserInfo() {
		try {
			let token = localStorage.getItem('token');
			const decoded = jwtDecode(token);
			return decoded['user'];
		} catch (error) {
			return null;
		}
	}

	static getUID() {
		try {
			let token = localStorage.getItem('token');
			const decoded = jwtDecode(token);
			return decoded['user']['_id'];
		} catch (error) {
			return null;
		}
	}

	static async getUserInfoByUID(uid) {
		try {
			var user = await Db.get('users', uid);
			return user;
		} catch (error) {
			return null;
		}
	}

	static async generateUserToken(uid) {
		try {
			var user = await this.getUserInfoByUID(uid);
			// console.dir(user);
			if (user != null) {
				var token = await Security.settoken(user._email);
				// console.dir(token);
				await Security.verifytoken(user._email, token.token, 'password');
				var login = await Security.login(user._email, 'password');
				localStorage.setItem('token', login.token);
				console.log(login.token);
				return login.token;
			} else {
				return null;
			}
		} catch (error) {
			return null;
		}
	}

	static deepCopy(array) {
		array = JSON.parse(JSON.stringify(array));
		return array;
	}

	static splice(array, index) {
		array.splice(index, 1);
		array = [...array.slice(0, index), ...array.slice(index + 1)];
		return array;
	}

	static validateEmail(email) {
		// Regular expression for basic email validation
		const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i;
		return emailRegex.test(String(email).toLowerCase());
	}

	static validatePassword(password) {
		if (password.length < 6) {
			return 'Password must be at least 6 characters long.';
		}

		// Check if the password contains at least one uppercase letter
		if (!/[A-Z]/.test(password)) {
			return 'Password must contain at least one uppercase letter.';
		}

		// Check if the password contains at least one lowercase letter
		if (!/[a-z]/.test(password)) {
			return 'Password must contain at least one lowercase letter.';
		}

		return '';
	}
	static hasPurchasedSoulprint(purchased_products) {
		// let data = [];
		try {
			console.log(purchased_products);
			if (purchased_products.indexOf('prod_RNHiLS62mZX04b') != -1) {
				return true;
			} else {
				return false;
			}
		} catch (error) {
			return false;
		}
	}

	static logoutUser() {
		localStorage.clear();
		window.location.href = `${window.location.origin}/login`;
	}

	static initialiseGoogleTracking() {
		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l !== 'dataLayer' ? '&l=' + l : '';
			j.async = true;
			j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, 'script', 'dataLayer', 'GTM-TKL33BB');
	}

	static getURLParameters() {
		const urlParams = new URLSearchParams(window.location.search);
		const paramsObject = Object.fromEntries(urlParams.entries());
		return paramsObject;
	}
}
